import { Injectable } from '@angular/core';
//import { image } from 'ngx-editor/schema/nodes';

export interface NavigationItem {
  id: string;
  title: string;
  type: 'item' | 'collapse' | 'group';
  translate?: string;
  icon?: string;
  image?: string;
  hidden?: boolean;
  url?: string;
  classes?: string;
  exactMatch?: boolean;
  external?: boolean;
  target?: boolean;
  breadcrumbs?: boolean;
  badge?: {
    title?: string;
    type?: string;
  };
  children?: Navigation[];
}

export interface Navigation extends NavigationItem {
  children?: NavigationItem[];
}

const NavigationItems = [


  {
    id: 'companylist',
    title: 'Business',
    type: 'item',
    icon: 'fas fa-building',
    url: '/business'
  },


  {
    id: 'navigation',
    type: 'group',
    children: [
      {
        id: 'accounts',
        title: 'Accounts',
        type: 'collapse',
        icon: 'feather icon-users',
        children: [
          {
            id: 'accounting period',
            title: 'Basic Information',
            type: 'item',
            url: '/accountingperiod',
            /*image:'../../../../../../assets/images/25.ico'*/
            /*icon:'feather icon-edit-1'*/
            //icon: 'fa-solid fa-money-check-dollar',
          },
          {
            id: 'pageselection',
            title: 'Page Selection',
            type: 'item',
            url: '/pageselection',
            //icon: 'fa-solid fa-clipboard-check',
            /*image: '../../../../../../assets/images/2.ico',*/
          },
          {
            id: 'partners_details',
            title: 'Partners Details',
            type: 'item',
            url: '/partners_details',
            /*icon:'feather icon-lock'*/
            //  image: '../../../../../../assets/images/Declaration.ico',
          },
          {
            id: 'trial-balance',
            title: 'Trial Balance',
            type: 'item',
            url: '/trial-balance',
            /*icon: 'fab fa-elementor'*/
            //  icon: 'fa-solid fa-scale-balanced'
          },
          {
            id: 'officerscompany',
            title: 'Officers Of the Company',
            type: 'item',
            url: '/officerscompany',
            /*icon:'fab fa-simplybuilt'*/
            //  icon: 'fa-solid fa-user-tie'
          },
          {
            id: 'thirdpartyagents',
            title: 'Third Party Agents',
            type: 'item',
            url: '/thirdpartyagents',
            /*icon: 'feather icon-tag'*/
            //  icon: 'fa-regular fa-address-card'
          },
          {
            id: 'auditorsreport',
            title: 'Auditors Report',
            type: 'item',
            url: '/auditorsreport',
            /*icon:'icon-file-text',*/
            //  icon: 'fa-solid fa-money-check'
          },
          {
            id: 'incomestatement',
            title: 'Income Statement',
            type: 'item',
            url: '/incomestatement',
            /*image: '../../../../../../assets/images/39.png'*/
            //icon: 'fa-solid fa-file-invoice-dollar'

          },
          {
            id: 'statementofcomprehensiveincome',
            title: 'Statement of Comprehensive Income',
            type: 'item',
            url: '/statementofcomprehensiveincome',
            /*image: '../../../../../../assets/images/Status-icon.gif'*/
            //  icon: 'fa-solid fa-file-invoice-dollar'
          },
          {
            id: 'statementoffinancialposition',
            title: 'Statement of Financial Position',
            type: 'item',
            url: '/statementoffinancialposition',
            //icon: 'fa-solid fa-money-bills'
            /*icon:'feather icon-grid'*/
          },
          {
            id: 'detailedprofitandlossaccount',
            title: 'Detailed Profit and Loss Account',
            type: 'item',
            url: '/detailedprofitandlossaccount',
            /*icon: 'feather icon-copy'*/
            //  icon: 'fa-solid fa-person-circle-check'
          },
         //removed changes in equity
          //{
          //  id: 'balancesheet',
          //  title: 'Financial Position_Balance Sheet2',
          //  type: 'item',
          //  url: '/balancesheet',
          //  icon:'feather icon-sliders'
          //},
          //{
          //  id: 'balancesheet',
          //  title: 'Financial Position_Balance Sheet2',
          //  type: 'item',
          //  url: '/balancesheet',
          //  icon:'feather icon-sliders'
          //},
          //{
          //  id: 'notes',
          //  title: 'Notes',
          //  type: 'item',
          //  url: '/notes'
          //},
          {
            id: 'notes',
            title: 'Notes Menu',
            type: 'collapse',
            /*icon: 'feather icon-book',*/
            //icon: 'fa-solid fa-chart-bar',
            children: [
              //{
              //  id: 'notes',
              //  title: 'Notes Menu',
              //  type: 'item',
              //  url: '/notes'
              //},
              {
                id: 'generalinformation',
                title: 'General Information',
                type: 'item',
                url: './generalinformation',
                MasterId: 1
                //  icon: 'icon-alert-circle',
              },
              {
                id: 'statementofcompliance',
                title: 'Statement Compliance',
                type: 'item',
                url: './statementofcompliance',
                MasterId: 2
              },
              {
                id: 'accountingpolicies',
                title: 'Accounting policies',
                type: 'item',
                url: './accountingpolicies',
                MasterId: 3
              },
              {
                id: 'turnover/revenue',
                title: 'Turnover / revenue',
                type: 'item',
                url: './turnover/revenue',
                MasterId: 4
                //  icon:'icon-refresh-cw',
              },
              {
                id: 'operatingprofit/(loss)',
                title: 'Operating profit/(loss)',
                type: 'item',
                url: './operatingprofit/(loss)',
                MasterId: 5
                //  icon:'icon-user-x',
              },
              {
                id: 'directorsremuneration',
                title: 'Director Remuneration',
                type: 'item',
                url: './directorsremuneration',
                MasterId: 6
              },
              {
                id: 'employees',
                title: 'Employees',
                type: 'item',
                url: './employees',
                MasterId: 7
                //  icon:'icon-people',
              },
              {
                id: 'taxation',
                title: 'Taxation',
                type: 'item',
                url: './taxation',
                MasterId: 9
                //  icon:'icon-hash',
              },
              {
                id: 'dividends',
                title: 'Dividends',
                type: 'item',
                url: './dividends',
                MasterId: 10
                //  icon:'icon-percent',
              },
              {
                id: 'inventories(stock)',
                title: 'Inventories',
                type: 'item',
                url: './inventories(stock)',
                MasterId: 11
              },
              {
                id: 'intangiblefixedassets',
                title: 'Intangible fixed assets',
                type: 'item',
                url: './intangiblefixedassets',
                MasterId: 12
              },

              {
                id: 'plantmachinery',
                title: 'Plant Machinery',
                type: 'item',
                url: './plantmachinery',
                MasterId: 13
              }, {
                id: 'landandbuildings',
                title: 'Land and buildings',
                type: 'item',
                url: './landandbuildings',
                MasterId: 14
              },
              {
                id: 'furnitureandfittings',
                title: 'Furniture and fittings',
                type: 'item',
                url: './furnitureandfittings',
                MasterId: 15
              },
              {
                id: 'officeequipment',
                title: 'Office Equipment',
                type: 'item',
                url: './officeequipment',
                MasterId: 16
              },
              {
                id: 'motorvehicles',
                title: 'Motor Vehicles',
                type: 'item',
                url: './motorvehicles',
                MasterId: 17
              },
              {
                id: 'computerequipment',
                title: 'Computer Equipment',
                type: 'item',
                url: './computerequipment',
                MasterId: 44
              },
              {
                id: 'financialassets(fixedassetinvestments)',
                title: 'Financial assets (Fixed asset investments)',
                type: 'item',
                url: './financialassets(fixedassetinvestments)',
                MasterId: 19
              },
              {
                id: 'debtors',
                title: 'Debtors',
                type: 'item',
                url: './debtors',
                MasterId: 20
              },
              {
                id: 'creditors-withinoneyear',
                title: 'Creditors - within one year',
                type: 'item',
                url: './creditors-withinoneyear',
                MasterId: 22
              },
              {
                id: 'creditors-morethanoneyear',
                title: 'Creditors - more than one year',
                type: 'item',
                url: './creditors-morethanoneyear',
                MasterId: 23
              },
              {
                id: 'borrowings',
                title: 'Borrowings',
                type: 'item',
                url: './borrowings',
                MasterId: 24
              },
              {
                id: 'operatingleasecommitments',
                title: 'Operating Lease Commitments',
                type: 'item',
                url: './operatingleasecommitments',
                MasterId: 26
              },
              {
                id: 'provisionsforliabilities',
                title: 'Provisions for liabilities',
                type: 'item',
                url: './provisionsforliabilities',
                MasterId: 28
              },
              {
                id: 'sharecapital',
                title: 'Share Capital',
                type: 'item',
                url: './sharecapital',
                MasterId: 29
              },
              {
                id: 'reserves/retainedprofit',
                title: 'Reserves Retained Profit',
                type: 'item',
                url: './reserves/retainedprofit',
                MasterId: 30
              },
              {
                id: 'revaluationreserve',
                title: 'Revaluation reserve',
                type: 'item',
                url: './revaluationreserve',
                MasterId: 31
              },
              {
                id: 'relatedpartytransactions',
                title: 'Related party transactions',
                type: 'item',
                url: './relatedpartytransactions',
                MasterId: 32
              },
              {
                id: 'transactionswithdirectors',
                title: 'Transactions With Directors',
                type: 'item',
                url: './transactionswithdirectors',
                MasterId: 33
              },
              {
                id: 'capitalcommitments',
                title: 'Capital commitments',
                type: 'item',
                url: './capitalcommitments',
                MasterId: 34
              },
              {
                id: 'contingentliabilities',
                title: 'Contingent liabilities',
                type: 'item',
                url: './contingentliabilities',
                MasterId: 35
              },
              {
                id: 'postbalancesheetevents',
                title: 'Post balance sheet events',
                type: 'item',
                url: './postbalancesheetevents',
                MasterId: 36
              },
              {
                id: 'directors’benefits',
                title: 'Directors Benefits',
                type: 'item',
                url: './directors’benefits',
                MasterId: 37
              },
              {
                id: 'accountingbasis',
                title: 'Accounting Basis',
                type: 'item',
                url: './accountingbasis',
                MasterId: 40
              },
              {
                id: 'tradecreditors',
                title: 'Trade Creditors',
                type: 'item',
                url: './tradecreditors',
                MasterId: 41
              },
              {
                id: 'loansandoverdrawnbankaccountbalances',
                title: 'Loans and Overdrawn Bank',
                type: 'item',
                url: './loansandoverdrawnbankaccountbalances',
                MasterId: 42
              },
              {
                id: 'otherliabilitiesandaccruals',
                title: 'Other liabilities and accruals',
                type: 'item',
                url: './otherliabilitiesandaccruals',
                MasterId: 43
              },
              {
                id: 'investmentsheldascurrentassets',
                title: 'Investment held as current assets',
                type: 'item',
                url: './investmentsheldascurrentassets',
                MasterId: 21
              },
              {
                id: 'loansandotherdebtsduetomembers',
                title: 'Loans and other debts due to members',
                type: 'item',
                url: './loansandotherdebtsduetomembers',
                MasterId: 25
              },
              {
                id: 'approvalstatement',
                title: 'Approval Statement',
                type: 'item',
                url: './approvalstatement'
              },
              {
                id: 'financialcommitments',
                title: 'Financial Commitments',
                type: 'item',
                url: '/financialcommitments',
                MasterId: 38
              },
              {
                id: 'off-balancesheetarrangements',
                title: 'Off Balance Sheet',
                type: 'item',
                url: '/off-balancesheetarrangements',
                MasterId: 39
              },
              //{
              //  id: 'interestpayable',
              //  title: 'Interest Payable',
              //  type: 'item',
              //  url: '/interestpayable'
              //},
              //{
              //  id: 'investmentproperty',
              //  title: 'Investment Property',
              //  type: 'item',
              //  url: '/investmentproperty'
              //},
              {
                id: 'deferredtaxation',
                title: 'Deferred Taxation',
                type: 'item',
                url: '/deferredtaxation'
              },


            ]
          },
          {
            id: 'directorsreport',
            title: 'Directors Report',
            type: 'item',
            url: '/directorsreport',
            /*icon:'icon-file-text',*/
            //  icon: 'fa-solid fa-money-check'
          },
          //{
          //  id: 'membersreport',
          //  title: 'Members Report',
          //  type: 'item',
          //  url: '/membersreport',
          //  /*icon:'icon-file-text',*/
          //  //  icon: 'fa-solid fa-money-check'
          //},
          {
            id: 'cashflowstatement',
            title: 'Cash Flow Statement',
            type: 'item',
            url: '/cashflow-statement',
            /*icon: 'feather icon-copy'*/
            //  icon: 'fa-solid fa-person-circle-check'
          },
          {
            id: 'statementofchangesinequity',
            title: "Statement of Changes in Equity",
            type: 'item',
            url: '/changesinequity'
            /*icon: 'feather icon-copy'*/
            //  icon: 'fa-solid fa-person-circle-check'
          },
          {
            id: 'approvalstatus',
            title: 'Approval of the Statutory Accounts',
            type: 'item',
            url: '/approvalstatus',
            /*icon: 'feather icon-copy'*/
            //  icon: 'fa-solid fa-person-circle-check'
          },
      
          {
            id: 'approvalstatement',
            title: 'Approval Statement',
            type: 'item',
            url: '/approvalstatement',
            //image: '../../../../../../assets/images/Declaration.ico',
            /*icon:'fas fa-newspaper',*/
          },
          //{
          //  id: 'computation',
          //  title: 'Computations',
          //  type: 'item',
          //  url: '/computation',
          //  //image: '../../../../../../assets/images/Declaration.ico',
          //  /*icon:'fas fa-newspaper',*/
          //},

        ]
      },

    ]
  },
  {
    id: 'navigation',
    type: 'group',
    children: [
      {
        id: 'computations',
        title: 'Computations',
        type: 'collapse',
        icon: 'feather icon-layers',
        children: [
          //{
          //  id: 'taxcomputations',
          //  title: 'Tax Computations',
          //  type: 'item',
          //  url: '/taxt_computation',
          //  icon: 'fa-solid fa-user',
          //},
          {
            id: 'computation',
            title: 'Computation Period',
            type: 'item',
            url: '/computation',
            //image: '../../../../../../assets/images/Declaration.ico',
            /*icon:'fas fa-newspaper',*/
          },
          {
            id: 'computations-information',
            title: 'Basic Information',
            type: 'item',
            url: '/computations-information',
            //  icon: 'fas fa-tools',
          },
          //{
          //  id: 'detailed-profitandloss',
          //  title: 'Detailed profit and loss',
          //  type: 'item',
          //  url: '/detailed-profitandloss',
          ////  icon: 'fas fa-th-list',
          //},
          {
            id: 'Computations',
            title: 'Tax Computations',
            type: 'item',
            url: '/adjustments',
            //  icon: 'fas fa-yen-sign',
          },
          //{
          //  id: 'balancing-charges',
          //  title: 'Capital Allowances/Balancing Charges',
          //  type: 'item',
          //  url: '/balancing-charges',
          ////  icon: 'fas fa-transgender-alt',
          //},
          ////{
          ////  id: 'machineryandplant',
          ////  title: 'Machinery and Plant',
          ////  type: 'item',
          ////  url: '/machineryandplant',
          ////  icon: 'fas fa-vihara',
          ////},
          ////{
          ////  id: 'researchdevelopmentallowances',
          ////  title: 'Research and Development Allowances',
          ////  type: 'item',
          ////  url: '/researchdevelopmentallowances',
          ////  icon: 'fas fa-window-restore',
          ////},
          ////{
          ////  id: 'othercaptialallowances',
          ////  title: 'Other capital allowances',
          ////  type: 'item',
          ////  url: '/other-captial-allowances',
          ////  icon: 'fas fa-tools',
          ////},
          ////{
          ////  id: 'summary-of-capital-allowances',
          ////  title: 'Summary of capital allowances',
          ////  type: 'item',
          ////  url: '/summary-of-capital-allowances',
          ////  icon: 'fas fa-transgender-alt',
          ////},
          //{
          //  id: 'tradingprofitloss',
          //  title: 'Adjusted trading profit/loss',
          //  type: 'item',
          //  url: '/tradingprofitloss',
          ////  icon: 'fas fa-transgender-alt',
          //},
          //{
          //  id: 'trading-losses',
          //  title: 'Trading losses',
          //  type: 'item',
          //  url: '/trading-losses',
          ////  icon: 'fas fa-transgender-alt',
          //},
          //{
          //  id: 'profitschargeable',
          //  title: 'Profits chargeable to Corporation Tax',
          //  type: 'item',
          //  url: '/profitschargeable',
          ////  icon: 'fas fa-transgender-alt',
          //},
          //{
          //  id: 'summary',
          //  title: 'Computations - Summary',
          //  type: 'item',
          //  url: '/summary',
          ////  icon: 'fas fa-wind',
          //},
          //{
          //  id: 'figures-transferred',
          //  title: 'Summary',
          //  type: 'item',
          //  url: '/figures-transferred',
          ////  icon: 'fas fa-list-ul',
          //},
        ]
      }
    ]
  },

   {
    id: 'status',
    title: 'Status',
    type: 'item',
    // icon: 'fas fa-check-double',
     image: '../../../../../../assets/images/status.png',
    url: '/formstatus'
  },

  {
    id: 'navigation',
    type: 'group',
    children: [
      {
        id: 'reports',
        title: 'Reports',
        type: 'collapse',
        icon: 'fa-solid fa-file',
        /*image:'../../../../../../assets/images/30.ico',*/
        children: [
          //{
          //  id: 'iXBRL reports',
          //  title: 'iXBRL Reports',
          //  type: 'item',
          //  url: '/reports',
          //  //icon: 'fa-solid fa-file-invoice'
          //  /*image: '../../../../../../assets/images/Client-Copy.png',*/
          //},
          {
            id: 'iXBRL reports',
            title: 'iXBRL Reports',
            type: 'collapse',
            //url: '/reports',
            //icon: 'fa-solid fa-file-invoice'
            /*image: '../../../../../../assets/images/Client-Copy.png',*/
            children: [
              {
                id: 'iXBRL reports',
                title: 'Accounts',
                type: 'item',
                url: '/reports/accounts',
              },
              {
                id: 'iXBRL_Computations_Reports',
                title: 'Computations',
                type: 'collapse',
                //url: '/reports',
                children: []
              },
              //{
              //  id: 'iXBRL_Computations_Reports',
              //  title: 'Computations',
              //  type: 'item',
              //  url: '/reports',
              //}

            ]

          },
            {
              id: 'iXBRL reports',
              title: 'Detailed Profit & Loss Report',
              type: 'item',
              url: '/reports/detailed',
            },
          {
            id: 'TrialBalanceReport', 
            title: 'Trial Balance Report',
            type: 'item',
            url: '/reports/trailbalance',
          },
          {
            id: 'TransactionsReport',
            title: 'Transactions Report',
            type: 'item',
            url: '/reports/transactionsreport',
          },
          {
            id: 'ChartofAccountsReports',
            title: 'Chart of Accounts Report',
            type: 'item',
            url: '/reports/chartofaccounts',
          }
          //{
          //  id: 'FbiReceipt',
          //  title: 'FBI Receipt',
          //  type: 'item',
          //  url: '/fbireceipt',
          //  //icon: 'fa-solid fa-receipt'
          //  /*image: '../../../../../../assets/images/39.png',*/
          //},

          //{
          //  id: 'iXBRL_Computations_Reports',
          //  title: 'iXBRL_Computations_Reports',
          //  type: 'item',
          //  url: '/reports',
          //  //icon: 'fa-solid fa-file-invoice'
          //  /*image: '../../../../../../assets/images/Client-Copy.png',*/
          //},

        ]
      },
      
      
    ]
  },

  {
    id: 'navigation',
    type: 'group',
    children: [
      {
        id: 'tools',
        title: 'Tools',
        type: 'collapse',
        icon: 'fa-solid fa-screwdriver-wrench',

        children: [
          {
            id: 'taxadviser',
            title: 'Tax Adviser  ',
            type: 'item',
            url: '/taxadviser',
            /*image: '../../../../../../assets/images/tax advisor details.gif',*/
            //  icon: 'fa-solid fa-user',
          },

          {
            id: 'Import',
            title: 'Import ',
            type: 'collapse',
            //   icon:'ti ti-database-import',
            /*   image: '../../../../../../assets/images/37.png',*/
            children: [
              {
                id: 'Previous period accounts data',
                title: 'Previous period accounts data',
                type: 'item',
                url: '/previous-period-accounts',
                //  image: '../../../../../../assets/images/import_256.ico',
              },
            ]
          },
          {
            id: 'user-accounts',
            title: 'User Management',
            type: 'item',
            url: '/user-accounts',
            //icon: 'fa-solid fa-users-gear',
            /*image: '../../../../../../assets/images/user account.gif',*/
          },
          {
            id: 'Clear Fields',
            title: 'Clear Fields ',
            type: 'item',
            url: '/clear',
            //icon: 'fa-solid fa-eraser'
            /*image: '../../../../../../assets/images/35.png',*/
          },
          {
            id: 'FbiReceipt',
            title: 'FBI Receipt',
            type: 'item',
            url: '/fbireceipt',
            //icon: 'fa-solid fa-receipt'
            /*image: '../../../../../../assets/images/39.png',*/
          },
          //{
          //  id: 'Show-Bubble',
          //  title: 'Show Bubble ',
          //  type: 'item',
          //  url: '/showbubble',
          //  //icon: 'fa-solid fa-eye'
          //  /*image: '../../../../../../assets/images/show-bubbles.png',*/
          //},
        ]
      }
    ]
  },
 

 
];
//var d = JSON.parse(typeof NavigationItems);
//console.log(d.NavigationItems["title"]);
//for (var i = 0; i < NavigationItems.length[0]; i++) {
//  d = NavigationItems[i];
//  console.log(d);
//}
var jdata = NavigationItems.find(t => t.id == 'reports');
console.log(jdata);

@Injectable()
export class NavigationItem {
  get() {
    return NavigationItems;
  }

  //  imageUrl = "../../../../../../assets/images/Quick-Start-icon.png";
}
